import { useRefreshStore } from "@/common/composables/refreshStore";
import { defineStore } from "pinia";
import { useListDashboardApi, type ListDashboardResponse } from "../api/listDashboardApi";
import { useDashboardStore } from "./dashboardStore";

export const useRefreshDashboardStore = defineStore('refresh-dashboards', () => {
  const listDashboardApi = useListDashboardApi();
  const store = useDashboardStore();

  return useRefreshStore<ListDashboardResponse>({
    fetchFromServer: () => listDashboardApi.execute(),
    mergeToStore(response) {
      store.merge(response.dashboards);
    },
  });
});
